import { ILightBoxImage } from '@models/ILightBoxImage';
import axios from 'axios';

const getLightBoxImages = async ({
  contentIds,
  language,
}: {
  contentIds: (number | string)[];
  language?: string;
}) => {
  const queries = contentIds.map((contentId: number | string) =>
    axios.get<ILightBoxImage>(`/api/v1/image/${contentId}?language=${language}`)
  );
  const responses = await Promise.all(queries);
  const response = responses.map(({ data }) => data);

  return response;
};

export default getLightBoxImages;
